var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataValue.value < 0)?_c('span',{staticClass:"negative"},[_vm._v(_vm._s(_vm.dataValue.text))]):_vm._e(),(_vm.dataValue.value > 0)?_c('span',[_vm._v(_vm._s(_vm.dataValue.text))]):_vm._e(),(_vm.dataValue.value == 0)?_c('span',[_vm._v(_vm._s("-"))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }